module.exports = __webpack_public_path__ + "img/be.b054c9df.svg";